<template>
  <img
    :class="this.classes"
    alt="avatar"
    :src="this.src"
    :style="{ background: this.background }" />
</template>
<script>
import avatarImage from '../assets/avatar_blank.png';

export default {
  name: 'dx-avatar',
  props: {
    src: {
      type: String,
      required: false,
      default: avatarImage,
    },
    size: {
      type: String,
      default: 'md',
      validator(size) {
        return ['xs', 'sm', 'md', 'lg', 'xl'].includes(size);
      },
    },
    background: {
      type: String,
      default: '#fff',
    },
  },
  computed: {
    classes() {
      const toSet = this.size;
      return ['dx-avatar', `dx-avatar--image--${toSet}`];
    },
  },
};
</script>
<style scoped lang="scss">
.dx-avatar {
  user-select: none;
  vertical-align: middle;
  border-radius: 80px;
}

.dx-avatar--image--xs {
  height: var(--dx-avatar-size--xs);
  width: var(--dx-avatar-size--xs);
}

.dx-avatar--image--sm {
  height: var(--dx-avatar-size--sm);
  width: var(--dx-avatar-size--sm);
}

.dx-avatar--image--md {
  height: var(--dx-avatar-size--md);
  width: var(--dx-avatar-size--md);
}

.dx-avatar--image--lg {
  height: var(--dx-avatar-size--lg);
  width: var(--dx-avatar-size--lg);
}

.dx-avatar--image--xl {
  height: var(--dx-avatar-size--xl);
  width: var(--dx-avatar-size--xl);
}

</style>
